// Mappa nome-servizio -> icona lucide-react per la vista pubblica della camera.
// Obiettivo: mostrare un simbolo pertinente al posto della spunta generica.
// Fallback: match per parola chiave, poi icona di default.
import {
  Wifi, Snowflake, Flame, Tv, Wine, Refrigerator, Lock, Wind, Gift, Shirt,
  Footprints, Cast, Usb, Phone, Speaker, BatteryCharging, Tablet, Radio,
  MonitorPlay, Coffee, CookingPot, Microwave, Sandwich, Utensils, WashingMachine,
  AirVent, Fan, Droplets, Bath, ShowerHead, Fence, Sun, Trees, Waves,
  ConciergeBell, Croissant, Car, Plane, Mountain, Building2, VolumeX, Layers,
  Accessibility, PawPrint, DoorOpen, CircleCheck,
} from 'lucide-react';

// Corrispondenza esatta con i nomi del catalogo (constants/hotelAmenities.js).
const EXACT = {
  // Popolari
  'Wi-Fi': Wifi,
  'Aria Condizionata': Snowflake,
  'Riscaldamento': Flame,
  'TV a Schermo Piatto': Tv,
  'Minibar': Wine,
  'Cassaforte': Lock,
  'Asciugacapelli': Wind,
  'Set Cortesia': Gift,
  'Accappatoio': Shirt,
  'Ciabatte': Footprints,
  // Elettronica
  'Smart TV': Tv,
  'Chromecast': Cast,
  'Presa USB': Usb,
  'Telefono': Phone,
  'Altoparlante Bluetooth': Speaker,
  'Dock Ricarica': BatteryCharging,
  'iPad in Camera': Tablet,
  'Radio Sveglia': Radio,
  'Proiettore': MonitorPlay,
  // Elettrodomestici
  'Macchina Caffè': Coffee,
  'Bollitore': CookingPot,
  'Microonde': Microwave,
  'Frigorifero': Refrigerator,
  'Tostapane': Sandwich,
  'Ferro da Stiro': Shirt,
  'Lavatrice': WashingMachine,
  'Asciugatrice': WashingMachine,
  'Lavastoviglie': Utensils,
  // Ventilazione
  'Aria Condizionata Split': AirVent,
  'Ventilatore a Soffitto': Fan,
  'Ventilatore Portatile': Fan,
  'Purificatore Aria': Wind,
  'Deumidificatore': Droplets,
  'Riscaldamento a Pavimento': Flame,
  // Servizi
  'Vasca Idromassaggio': Bath,
  'Doccia a Pioggia': ShowerHead,
  'Sauna Privata': Flame,
  'Balcone': Fence,
  'Terrazza': Sun,
  'Giardino Privato': Trees,
  'Piscina Privata': Waves,
  'Cucina Completa': Utensils,
  'Angolo Cottura': CookingPot,
  'Lavasecco': Shirt,
  'Servizio in Camera 24h': ConciergeBell,
  'Colazione Inclusa': Croissant,
  'Parcheggio Privato': Car,
  'Trasferimento Aeroporto': Plane,
  // Caratteristiche
  'Vista Mare': Waves,
  'Vista Montagna': Mountain,
  'Vista Città': Building2,
  'Vista Giardino': Trees,
  'Insonorizzata': VolumeX,
  'Camino': Flame,
  'Soppalco': Layers,
  'Terrazza Panoramica': Mountain,
  'Accesso Disabili': Accessibility,
  'Pet Friendly': PawPrint,
  'Piano Alto': Building2,
  'Ingresso Indipendente': DoorOpen,
};

// Match per parola chiave (per amenity custom non a catalogo).
const KEYWORDS = [
  [['wifi', 'wi-fi', 'internet'], Wifi],
  [['condizionata', 'clima', 'a/c', 'air'], Snowflake],
  [['riscald', 'termo', 'caldo'], Flame],
  [['smart tv', ' tv', 'televis'], Tv],
  [['minibar', 'frigobar', 'vino', 'wine'], Wine],
  [['cassaforte', 'safe', 'lucchetto', 'serratura'], Lock],
  [['asciugacapelli', 'phon', 'hair'], Wind],
  [['cortesia', 'kit', 'omaggio'], Gift],
  [['accappatoio', 'vestaglia'], Shirt],
  [['ciabatte', 'pantofole', 'slipper'], Footprints],
  [['chromecast', 'streaming'], Cast],
  [['usb', 'presa', 'ricarica'], Usb],
  [['telefono', 'phone'], Phone],
  [['bluetooth', 'altoparlant', 'speaker', 'cassa'], Speaker],
  [['dock', 'caricabatt'], BatteryCharging],
  [['ipad', 'tablet'], Tablet],
  [['radio', 'sveglia'], Radio],
  [['proiettore', 'projector'], MonitorPlay],
  [['caffè', 'caffe', 'coffee', 'espresso'], Coffee],
  [['bollitore', 'kettle', 'the', 'tè'], CookingPot],
  [['microonde', 'microwave', 'forno'], Microwave],
  [['frigo', 'refriger'], Refrigerator],
  [['tostapane', 'toast'], Sandwich],
  [['ferro', 'stiro'], Shirt],
  [['lavatrice', 'lavabianch'], WashingMachine],
  [['asciugatrice'], WashingMachine],
  [['lavastovigl', 'stovigl', 'piatti'], Utensils],
  [['ventilator', 'fan'], Fan],
  [['purificat', 'aria'], Wind],
  [['deumidif', 'umidit'], Droplets],
  [['idromassaggio', 'vasca', 'jacuzzi'], Bath],
  [['doccia', 'shower'], ShowerHead],
  [['sauna', 'camino', 'fuoco'], Flame],
  [['balcone', 'recinto'], Fence],
  [['terrazza', 'terrazzo', 'patio'], Sun],
  [['giardino', 'garden', 'verde', 'parco'], Trees],
  [['piscina', 'pool', 'mare', 'spiaggia'], Waves],
  [['cucina', 'cottura', 'kitchen'], Utensils],
  [['lavasecco', 'lavanderia', 'laundry'], Shirt],
  [['servizio in camera', 'room service', 'concierge'], ConciergeBell],
  [['colazione', 'breakfast', 'brunch'], Croissant],
  [['parcheggio', 'garage', 'parking', 'auto'], Car],
  [['aeroporto', 'transfer', 'navetta', 'shuttle'], Plane],
  [['montagna', 'mountain', 'vetta'], Mountain],
  [['città', 'citta', 'city', 'urban'], Building2],
  [['insonorizz', 'silenzio', 'soundproof'], VolumeX],
  [['soppalco', 'loft', 'piani'], Layers],
  [['disabili', 'accessib', 'wheelchair'], Accessibility],
  [['pet', 'animal', 'cane', 'gatto'], PawPrint],
  [['ingresso', 'entrata', 'porta', 'door'], DoorOpen],
  [['sole', 'panoram', 'vista'], Sun],
];

/**
 * Ritorna il componente icona lucide per un nome di servizio.
 * @param {string} name
 * @returns {import('lucide-react').LucideIcon}
 */
export function amenityIcon(name) {
  if (!name) return CircleCheck;
  if (EXACT[name]) return EXACT[name];
  const n = String(name).toLowerCase();
  for (const [keys, Icon] of KEYWORDS) {
    if (keys.some((k) => n.includes(k))) return Icon;
  }
  return CircleCheck;
}

export default amenityIcon;
